import React, { memo, useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import icon_app_tgs from "assets/svg/icon_app_tgs.svg";
import icon_cancel_input_phone from "assets/icon_cancel_input_phone.svg";
import icon_arrow_back from "assets/icon_arrow_back.svg";
import { useTranslation } from "react-i18next";
import icon_cancel_dialog from "assets/icon_cancel_dialog.png";
import icon_placeholder_password from "assets/icon_placeholder_password.svg";
import icon_checked_password from "assets/icon_checked_password.svg";
import icon_show_password from "assets/icon_show_password.svg";
import icon_hide_password from "assets/icon_hide_password.svg";
import ic_uncheck_create_user from "assets/ic_uncheck_create_user.svg";
import icon_toast_success from "assets/icon_toast_success.png";
import icon_info_dialog from "assets/icon_info_dialog.svg";
import { useSelector, useDispatch } from "react-redux";
import { setInfoUserTgs } from "redux/action";
import { notification, Modal } from "antd";
import ModalLoading from "components/modal/Loading";
import { toast } from "react-toastify";
import ServiceBase, { checkNetworkConnection } from "utils/ServiceBase";
import {
  setOpenNoInternetModal,
  pushApiErrorData,
  setApiErrorOpen,
  setInfoTgsV3,
} from "redux/action";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import ModalWarning from "containers/login/ModalWarning";
import ModalNotifyWrongOtp from "containers/login/ModalNotifyWrongOtp";
import ModalForgotPassword from "containers/login/ModalForgotPassword";
import ModalTermAndCondition from "containers/login/ModalTermAndCondition";
import ModalContent from "components/modal";
import ModalContentV2 from "components/modal/ModalV2";
import { InputOTP } from "antd-input-otp";
import {
  APP_LOGIN_CALLBACK_PATH,
  APP_LOGIN_CALLBACK_WARNING,
  APP_LOGIN_RETURN_PATH_STORAGE_KEY,
  APP_LOGIN_STATE_STORAGE_KEY,
  RECAPTCHA_KEY,
} from "utils/constants";
import StepPointAccrual from "./StepPointAccrual";
import { useLocation, useNavigate } from "react-router-dom";
import { webEventExtraParams } from "utils";
import uuid from "react-uuid";
import { ReactComponent as IconInfoWarningDialog } from "assets/icon_info_warning_dialog.svg";
import { normalizeTgsLoginData } from "utils/tgsLogin";
import { splitAppLoginCallbackMessage } from "utils/appLoginCallback";

const APP_LOGIN_CALLBACK_WARNING_DELAY_MS = 250;

const getAppLoginStateFromDeepLink = (deepLink) => {
  try {
    const oneLinkUrl = new URL(deepLink);
    const directState = oneLinkUrl.searchParams.get("state");
    if (directState) return directState;

    const appDeepLink = oneLinkUrl.searchParams.get("af_dp");
    if (!appDeepLink) return "";

    return new URL(appDeepLink).searchParams.get("state") || "";
  } catch (error) {
    return "";
  }
};

const ModalLoginInner = memo(
  ({
    className,
    onCancel,
    isFromCart,
    setIsFromPayment,
    onShowModal,
    isFromUrl,
  }) => {
    const { t } = useTranslation("translation");
    const navigate = useNavigate();
    const location = useLocation();
    const isLanguageEnglish = useSelector(
      (state) => state.rootReducer.isLanguageEnglish,
    );
    const homeBrand = useSelector((state) => state.rootReducer.homeBrand);
    const dispatch = useDispatch();
    const { executeRecaptcha } = useGoogleReCaptcha();

    const [loading, setLoading] = useState(false);
    const [isEnableButton, setEnableButton] = useState(false);
    const [isEnableButtonPassword, setEnableButtonPassword] = useState(false);
    const [isPhoneNumberSuccess, setPhoneNumberSuccess] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [dataUserInfo, setDataUserInfo] = useState("");
    const [isShowModalWarning, setModalWarning] = useState([false, false]);
    const [isShowModalForgotPassword, setModalForgotPassword] = useState(false);
    const [isErrorPhoneNumber, setErrorPhoneNumber] = useState(false);
    const [isShowOTP, setShowOTP] = useState(false);
    const [otp, setOtp] = useState([]);
    const [isEnableButtonVerifyOTP, setEnableButtonVerifyOTP] = useState(false);
    const [seconds, setSeconds] = useState(0);
    const [isModalNotifyWrongOtp, setModalNotifyWrongOtp] = useState([
      false,
      false,
    ]);
    const [errorOtp, setErrorOtp] = useState("");
    const [errorPassword, setErrorPassword] = useState("");
    const [isShowPasswordView, setShowPasswordView] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [createPassword, setCreatePassword] = useState("");
    const [isShowPlaceHolder, setShowPlaceHolder] = useState(true);
    const [isShowPlaceHolderConfirm, setShowPlaceHolderConfirm] =
      useState(true);
    const [isShowPassword, setShowPassword] = useState(true);
    const [isShowPasswordConfirm, setShowPasswordConfirm] = useState(true);
    const [isShowErrorCreatePassword, setShowErrorCreatePassword] =
      useState(false);
    const [isShowErrorConfirmPassword, setShowErrorConfirmPassword] =
      useState(false);
    const [isShowModalConfirmClose, setShowModalConfirmClose] = useState(false);
    const [isShowPasswordLogin, setShowPasswordLogin] = useState(true);
    const [isShowModalError, setShowModalError] = useState([false, ""]);
    const [isChecked, setChecked] = useState(true);
    const [isShowModalTermAndCondition, setShowModalTermAndCondition] =
      useState(false);
    const [isShowAppLoginWarning, setShowAppLoginWarning] = useState(false);
    const [appLoginWarningMessage, setAppLoginWarningMessage] = useState("");
    const appLoginWarningMessageParts = splitAppLoginCallbackMessage(
      appLoginWarningMessage,
    );
    const [appLoginCallbackWarning, setAppLoginCallbackWarning] = useState("");
    const [appLoginCallbackMessage, setAppLoginCallbackMessage] = useState("");
    const appLoginCallbackMessageParts = splitAppLoginCallbackMessage(
      appLoginCallbackMessage,
    );

    useEffect(() => {
      const callbackWarning = location.state?.appLoginCallbackWarning || "";
      if (!callbackWarning) return undefined;

      // Wait for the parent login modal's opening animation to finish so the
      // callback warning is always displayed on top of an already-visible UI.
      const warningTimer = window.setTimeout(() => {
        setAppLoginCallbackWarning(callbackWarning);
        setAppLoginCallbackMessage(
          location.state?.appLoginCallbackMessage || "",
        );
      }, APP_LOGIN_CALLBACK_WARNING_DELAY_MS);

      return () => window.clearTimeout(warningTimer);
    }, [
      location.state?.appLoginCallbackMessage,
      location.state?.appLoginCallbackWarning,
    ]);

    const closeAppLoginCallbackWarning = () => {
      setAppLoginCallbackWarning("");
      setAppLoginCallbackMessage("");
      navigate(location.pathname, { replace: true, state: null });
    };

    const onCancelModal = () => {
      if (typeof onCancel === "function") {
        onCancel();
        return;
      }
      navigate("/products");
    };
    const handlePushApiError = (api) => {
      dispatch(pushApiErrorData([api]));
    };

    const handleShowApiErrors = () => {
      notification.close("gpos-key");
      dispatch(setApiErrorOpen(true));
    };

    const handleCheckNetworkConnect = () => {
      if (checkNetworkConnection()) return true;
      dispatch(setOpenNoInternetModal(true));
      return false;
    };

    const showTimeoutError = (url, response) => {
      if (response?.code === "ECONNABORTED") {
        handlePushApiError({ url, time: Date.now() });
        notification["error"]({
          key: "internalServerError",
          message: t("internalServerError"),
          duration: 15,
          description: (
            <span style={{ color: "#2083DA" }} onClick={handleShowApiErrors}>
              {t("forDev")}
            </span>
          ),
        });
        return true;
      }
      return false;
    };

    const showModalErrorMessage = (response) => {
      setShowModalError([
        true,
        response?.value?.mess ||
          response?.value?.message ||
          response?.message ||
          t("error"),
      ]);
    };

    const getResponseCode = (response) => {
      return String(response?.value?.code || "");
    };

    const showLoadingBeforeRequest = async () => {
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 0));
    };

    const setValueOtp = (value) => {
      setOtp(value);
      const filteredList = value.filter((item) => item !== "");
      setEnableButtonVerifyOTP(filteredList.length === 4);
    };

    const onClearDataInfo = () => {
      setEnableButton(false);
      setErrorPassword("");
      setPhoneNumber("");
      setDataUserInfo("");
      setPhoneNumberSuccess(false);
    };

    useEffect(() => {
      setPassword("");
    }, []);

    useEffect(() => {
      if (!isShowOTP) return;

      const interval = setInterval(() => {
        setSeconds((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);

      return () => clearInterval(interval);
    }, [isShowOTP]);

    const userSignUpCdp = (info) => {
      window.web_event.track("user", "sign_up", {
        dims: {
          purchase: {
            id: homeBrand.qrCode,
            name: homeBrand?.qrCode,
          },
        },
        extra: {
          language: isLanguageEnglish ? "eng" : "vie",
          ...webEventExtraParams(homeBrand),
        },
      });
    };

    const userSignInCdp = (info) => {
      window.web_event.track("user", "sign_in", {
        dims: {
          purchase: {
            id: homeBrand.qrCode,
            name: homeBrand?.qrCode,
          },
        },
        extra: {
          language: isLanguageEnglish ? "eng" : "vie",
          ggg_user_id: info?.["customer-number"],
          ...webEventExtraParams(homeBrand),
        },
      });
    };

    const requestOtp = useCallback(
      async (phone) => {
        if (!executeRecaptcha) {
          console.log("Execute recaptcha not yet available");
          return;
        }

        const token = await executeRecaptcha("submit_form");
        if (!token) return;

        await showLoadingBeforeRequest();

        const url = `/ggg/api/v2.0/tgs-connect/request-otp-cap`;
        const response = await ServiceBase.requestJson({
          method: "POST",
          url,
          data: {
            "phone-number": phone,
            type: 1,
            provider: 1,
            language: isLanguageEnglish ? 2 : 1,
            "captcha-token": token,
          },
        });

        if (response?.value?.code === "200") {
          setShowOTP(true);
          setPhoneNumberSuccess(false);
          setLoading(false);
          setSeconds(59);
        } else if (response?.value?.code === "203") {
          setLoading(false);
          showModalErrorMessage(response);
        } else {
          setLoading(false);
          if (!showTimeoutError(url, response)) {
            showModalErrorMessage(response);
          }
        }
      },
      [executeRecaptcha, isLanguageEnglish, t],
    );

    const resendOTP = useCallback(() => {
      requestOtp(phoneNumber);
    }, [phoneNumber, requestOtp]);

    const qrOrderConsent = useCallback(async () => {
      if (!handleCheckNetworkConnect()) return;
      const url = `/ggg/api/v1.0/policy/qr-order-consent`;
      const response = await ServiceBase.requestJson({
        method: "POST",
        url,
        data: {
          "phone-number": phoneNumber,
          "originate-from": "Màn hình đăng nhập",
        },
      });

      if (response?.value?.code !== "200") {
        if (!showTimeoutError(url, response)) {
          showModalErrorMessage(response);
        }
      }
    }, [phoneNumber, t]);

    const checkPhoneNumber = useCallback(async () => {
      if (!handleCheckNetworkConnect()) return;

      await showLoadingBeforeRequest();
      const url = `/ggg/api/v3.0/tgs-connect/check-user-existed?phone-number=${phoneNumber}`;
      const response = await ServiceBase.requestJson({
        method: "GET",
        url,
        data: {},
      });

      const responseCode = getResponseCode(response);

      if (responseCode === "200") {
        setDataUserInfo(response?.value?.data);
        setShowOTP(false);
        setPhoneNumberSuccess(true);
        setLoading(false);
        qrOrderConsent();
      } else if (responseCode === "203") {
        setLoading(false);
        requestOtp(phoneNumber);
      } else if (responseCode === "204") {
        setShowOTP(false);
        setPhoneNumberSuccess(false);
        setLoading(false);
        setModalWarning([true, true]);
      } else if (responseCode === "205") {
        setShowOTP(false);
        setPhoneNumberSuccess(false);
        setLoading(false);
        setModalWarning([true, false]);
      } else if (responseCode === "206") {
        setShowOTP(false);
        setPhoneNumberSuccess(false);
        setLoading(false);
        showModalErrorMessage(response);
      } else {
        setShowOTP(false);
        setPhoneNumberSuccess(false);
        setLoading(false);
        showModalErrorMessage(response);
        // if (!showTimeoutError(url, response)) {
        //   showModalErrorMessage(response);
        // }
      }
    }, [phoneNumber, requestOtp, qrOrderConsent, t]);

    const onLoginV3 = useCallback(async () => {
      if (!handleCheckNetworkConnect()) return;

      await showLoadingBeforeRequest();
      const payload = {
        "user-name": phoneNumber,
        password,
      };
      const url = `/ggg/api/v3.0/tgs-connect/login`;
      const response = await ServiceBase.requestJson({
        method: "POST",
        url,
        data: payload,
      });
      const responseCode = getResponseCode(response);

      if (responseCode === "200") {
        setLoading(false);
        setErrorPassword("");
        setModalNotifyWrongOtp([false, false]);

        const info = normalizeTgsLoginData(
          response.value?.data,
          homeBrand?.qrCode,
        );
        dispatch(setInfoUserTgs(info));
        dispatch(setInfoTgsV3(info));

        if (isFromCart) {
          onContinuePayment();
        } else {
          // onShowModal();
          onCancelModal();
        }
      } else if (responseCode === "203") {
        setModalNotifyWrongOtp([true, true]);
        setErrorPassword("");
        setLoading(false);
      } else if (responseCode === "204") {
        setErrorPassword(response?.value?.data?.["remaining-login"]);
        setModalNotifyWrongOtp([false, false]);
        setLoading(false);
      } else if (responseCode === "205") {
        setErrorPassword("");
        setModalNotifyWrongOtp([false, false]);
        setLoading(false);
        showModalErrorMessage(response);
      } else if (responseCode === "206") {
        setErrorPassword("");
        setModalNotifyWrongOtp([false, false]);
        setLoading(false);
        showModalErrorMessage(response);
      } else {
        setErrorPassword(response?.value?.data?.["remaining-login"] || "");
        setModalNotifyWrongOtp([false, false]);
        setLoading(false);
        showModalErrorMessage(response);

        // if (!showTimeoutError(url, response)) {
        //   showModalErrorMessage(response);
        // }
      }
    }, [phoneNumber, password, isFromCart, homeBrand, t]);

    const onLogin = useCallback(async () => {
      if (!handleCheckNetworkConnect()) return;

      await showLoadingBeforeRequest();
      const payload = {
        username: phoneNumber,
        password,
        guid: `{${homeBrand?.qrCode}}`,
      };
      const url = `/ggg/api/v2.0/tgs-connect/login`;
      const response = await ServiceBase.requestJson({
        method: "POST",
        url,
        data: payload,
      });

      if (response?.value?.code === "200") {
        setErrorPassword("");
        setModalNotifyWrongOtp([false, false]);

        const info = response.value?.data;
        info.guid = homeBrand?.qrCode;
        dispatch(setInfoUserTgs(info));
        userSignInCdp(info);

        setLoading(false);
        if (isFromCart) {
          onContinuePayment();
        } else {
          // onShowModal();
          onCancelModal();
        }
      } else if (response?.value?.code === "203") {
        setModalNotifyWrongOtp([true, true]);
        setErrorPassword("");
        setLoading(false);
      } else if (response?.value?.code === "204") {
        setErrorPassword(response?.value?.data?.["remaining-login"]);
        setModalNotifyWrongOtp([false, false]);
        setLoading(false);
      } else if (response?.value?.code === "205") {
        setErrorPassword("");
        setModalNotifyWrongOtp([false, false]);
        setLoading(false);
        showModalErrorMessage(response);
      } else {
        setErrorPassword("");
        setModalNotifyWrongOtp([false, false]);
        setLoading(false);

        if (!showTimeoutError(url, response)) {
          showModalErrorMessage(response);
        }
      }
    }, [phoneNumber, password, isFromCart, homeBrand, t]);

    const onSendOtp = () => {
      // if (!otp || otp.length <= 3) return;

      // let payload = "";
      // otp.forEach((p) => {
      //   if (p !== "") payload += p;
      // });

      // if (payload.length <= 3) return;
      // if (!handleCheckNetworkConnect()) return;

      // setLoading(true);
      // const url = `/ggg/api/v2.0/tgs-connect/verify-otp`;
      // const response = await ServiceBase.requestJson({
      //   method: "POST",
      //   url,
      //   data: {
      //     "phone-number": phoneNumber,
      //     "verification-code": payload,
      //   },
      // });

      // if (response?.value?.code === "200") {
      //   setErrorOtp("");
      //   setModalNotifyWrongOtp([false, false]);
      //   setLoading(false);
      //   setShowPasswordView(true);
      //   setShowOTP(false);
      // } else if (response?.value?.code === "203") {
      //   setErrorOtp("");
      //   setModalNotifyWrongOtp([true, false]);
      //   setLoading(false);
      //   setShowPasswordView(false);
      // } else if (response?.value?.code === "204") {
      //   setErrorOtp(response?.value?.data?.["remaining-verification"]);
      //   setModalNotifyWrongOtp([false, false]);
      //   setLoading(false);
      //   setShowPasswordView(false);
      // } else {
      //   setErrorOtp("");
      //   setShowPasswordView(false);
      //   setModalNotifyWrongOtp([false, false]);
      //   setLoading(false);

      //   if (!showTimeoutError(url, response)) {
      //     showModalErrorMessage(response);
      //   }
      // }
      setErrorOtp("");
      setModalNotifyWrongOtp([false, false]);
      setLoading(false);
      setShowPasswordView(true);
      setShowOTP(false);
    };

    const registerAccount = useCallback(async () => {
      if (!handleCheckNetworkConnect()) return;
      if (!otp || otp.length <= 3) return;

      let payload = "";
      otp.forEach((p) => {
        if (p !== "") payload += p;
      });

      if (payload.length <= 3) return;
      if (!handleCheckNetworkConnect()) return;

      await showLoadingBeforeRequest();
      const url = `/ggg/api/v3.0/tgs-connect/register`;
      const response = await ServiceBase.requestJson({
        method: "POST",
        url,
        data: {
          "phone-number": phoneNumber,
          password: createPassword,
          "verification-code": payload,
        },
      });

      if (response?.value?.code === "200") {
        const info = response.value?.data;
        info.guid = homeBrand?.qrCode;

        userSignUpCdp(info);
        userSignInCdp(info);
        dispatch(setInfoUserTgs(info));
        dispatch(setInfoTgsV3(info));

        if (isFromCart) {
          onContinuePayment();
        } else {
          // onShowModal();
          onCancelModal();
        }

        toast.success(
          <div className="font-500 text-black">
            {t("textConfirmSignUpSuccess")}
          </div>,
          {
            icon: () => <img src={icon_toast_success} alt="success" />,
            className: "toast_one_line",
          },
        );
      } else if (
        response?.value?.code === "203" ||
        response?.value?.code === "204"
      ) {
        // onCancel();
        showModalErrorMessage(response);
      } else {
        // onCancel();
        if (!showTimeoutError(url, response)) {
          showModalErrorMessage(response);
        }
      }
    }, [phoneNumber, createPassword, isFromCart, homeBrand, t]);

    const isPhoneNumberValid = (value) => {
      return value.charAt(0) === "0" && value.length >= 10;
    };

    const onInputPass = () => {
      if (phoneNumber === "") return;

      if (isValidateContinue()) {
        checkPhoneNumber();
      } else {
        setPhoneNumberSuccess(false);
      }
    };

    const clearPhone = () => {
      setPhoneNumber("");
      setEnableButton(false);
    };

    const onContinuePayment = () => {
      setIsFromPayment(true);
      onCancel();
    };

    const onLoginWithGoldenGateApp = async () => {
      if (!handleCheckNetworkConnect()) return;

      const showAppLoginWarning = (message = "") => {
        const normalizedMessage =
          typeof message === "string" ? message.trim() : "";
        setAppLoginWarningMessage(
          normalizedMessage || t("cannotOpenGoldenGateApp"),
        );
        setShowAppLoginWarning(true);
      };

      const orderGuid = String(homeBrand?.qrCode || "").replace(/[{}]/g, "");

      if (!orderGuid) {
        showAppLoginWarning();
        return;
      }

      const url = `/ggg/api/v3.0/tgs-connect/qr-order/app-login/init`;
      localStorage.removeItem(APP_LOGIN_STATE_STORAGE_KEY);
      localStorage.removeItem(APP_LOGIN_RETURN_PATH_STORAGE_KEY);
      await showLoadingBeforeRequest();

      const response = await ServiceBase.requestJson({
        method: "POST",
        url,
        data: {
          "order-guid": `{${orderGuid}}`,
          "session-id": `qr-session-${uuid()}`,
          "callback-url": APP_LOGIN_CALLBACK_PATH,
        },
      });

      setLoading(false);

      const responseData = response?.value?.data;
      const deepLink = responseData?.["deep-link"] || responseData?.deeplink;

      if (
        String(response?.value?.code || "") !== "200" ||
        typeof deepLink !== "string" ||
        !deepLink.trim()
      ) {
        showAppLoginWarning(response?.value?.mess || response?.mess);
        return;
      }

      const appLoginState =
        responseData?.state || getAppLoginStateFromDeepLink(deepLink.trim());

      if (!appLoginState) {
        showAppLoginWarning();
        return;
      }

      localStorage.setItem(
        APP_LOGIN_STATE_STORAGE_KEY,
        String(appLoginState),
      );
      localStorage.setItem(
        APP_LOGIN_RETURN_PATH_STORAGE_KEY,
        location.pathname,
      );

      window.location.href = deepLink.trim();
    };

    const isValidateContinue = () => {
      if (!isPhoneNumberValid(phoneNumber)) {
        notification["error"]({
          message: t("phoneValidError"),
          description: "",
        });
        setErrorPhoneNumber(true);
        return false;
      }

      if (!isChecked) {
        notification["error"]({
          message: t("policyValidError"),
          description: "",
        });
        return false;
      }

      setErrorPhoneNumber(false);
      return true;
    };

    const setValuePhoneNumber = (phone) => {
      setEnableButton(phone !== "");
      setPhoneNumber(phone);
    };

    const setValuePass = (value) => {
      setEnableButtonPassword(value !== "");
      setPassword(value);
    };

    const onCancelModalWarning = () => {
      setModalWarning([false, false]);
    };

    const onClearShowOtp = () => {
      setEnableButton(false);
      setPhoneNumberSuccess(false);
      setPhoneNumber("");
      setShowOTP(false);
      setOtp([]);
      setErrorOtp("");
    };

    const onClearCreatePassword = () => {
      setCreatePassword("");
      setPasswordConfirm("");
      setShowModalConfirmClose(true);
    };

    const onCancelModalNotifyWrongOtp = () => {
      setModalNotifyWrongOtp([false, false]);
      onCancelModal();
    };

    const onCancelModalForgotPassword = () => {
      setModalForgotPassword(false);
    };

    const setValueCreatePassword = (pass) => {
      setShowPlaceHolder(pass === "");
      setCreatePassword(pass);
    };

    const setValueConfirmPassword = (pass) => {
      setShowPlaceHolderConfirm(pass === "");
      setPasswordConfirm(pass);
    };

    const onConfirmModalConfirmClose = () => {
      if (isFromUrl) {
        navigate(0);
      } else {
        onCancel();
      }
    };

    const onCancelShowModalTermOf = () => {
      setShowModalTermAndCondition(false);
    };

    const onShowModalTermAndCondition = () => {
      setShowModalTermAndCondition(true);
    };

    function getHighlightedText(text, highlight) {
      const parts = text.split(new RegExp(`(${highlight})`, "gi"));
      return parts.map((part, index) => (
        <React.Fragment key={index}>
          {part.toLowerCase() === highlight.toLowerCase() ? (
            <b style={{ color: "#2083DA", fontSize: 15 }}>{part}</b>
          ) : (
            part
          )}
        </React.Fragment>
      ));
    }

    const setValueShowPassword = () => {
      setShowPassword(!isShowPassword);
    };

    const setValueShowPasswordLogin = () => {
      setShowPasswordLogin(!isShowPasswordLogin);
    };

    const setValueShowPasswordConfirm = () => {
      setShowPasswordConfirm(!isShowPasswordConfirm);
    };

    const onConfirmPassword = () => {
      if (!isChecked) return;

      if (createPassword.length < 6) {
        setShowErrorCreatePassword(true);
        return;
      }

      if (createPassword !== passwordConfirm) {
        setShowErrorCreatePassword(false);
        setShowErrorConfirmPassword(true);
        return;
      }

      setShowErrorCreatePassword(false);
      setShowErrorConfirmPassword(false);
      registerAccount();
    };

    const onCheck = useCallback(() => {
      setChecked((prev) => !prev);
    }, []);

    const renderPasswordView = () => {
      return (
        <div>
          {!isFromCart && (
            <div
              onClick={() => {
                onClearCreatePassword();
              }}
              className=" absolute icon_cancel ml-2 top-0 left-0"
            >
              <img src={icon_cancel_dialog} alt="cart" />
            </div>
          )}
          <div>
            <div
              className={"flex justify-center items-center goldenSpoons mt-4"}
            >
              {t("titlePasswordTab")}
            </div>

            <div className={"flex justify-center items-center"}>
              <div
                className={
                  "flex w-5/6 justify-center items-center text-center mt-1 contentPassword"
                }
              >
                {t("contentPasswordTab")}
              </div>
            </div>

            <div className={" w-full ml-3"}>
              <div className={"flex mt-1 contentPassword"}>
                {t("titleCreatePassword")}
              </div>
              <div className={"input-phone relative mt-3.5 mr-7"}>
                <div className={"h-11"}>
                  <input
                    type={isShowPassword ? "password" : "text"}
                    maxLength={15}
                    onChange={(e) => setValueCreatePassword(e.target.value)}
                  />
                  <img
                    onClick={setValueShowPassword}
                    className={" absolute top-0 bottom-0  right-0 mt-2 mr-3"}
                    src={
                      isShowPassword ? icon_show_password : icon_hide_password
                    }
                    alt="cart"
                  />
                  {isShowPlaceHolder && (
                    <img
                      className={" absolute top-0 bottom-0 mt-4 ml-2"}
                      src={icon_placeholder_password}
                      alt="cart"
                    />
                  )}
                </div>
              </div>
              {isShowErrorCreatePassword && (
                <div className={"text-error-phone"}>
                  {t("errorPasswordCreate")}
                </div>
              )}
            </div>

            <div className={" w-full ml-3 mt-5"}>
              <div className={"flex mt-1 contentPassword"}>
                {t("titleConfirmPassword")}
              </div>
              <div className={"input-phone relative mt-3.5 mr-7"}>
                <div className={"h-11"}>
                  <input
                    type={isShowPasswordConfirm ? "password" : "text"}
                    maxLength={15}
                    onChange={(e) => setValueConfirmPassword(e.target.value)}
                  />
                  <img
                    onClick={setValueShowPasswordConfirm}
                    className={" absolute top-0 bottom-0  right-0 mt-2 mr-3"}
                    src={
                      isShowPasswordConfirm
                        ? icon_show_password
                        : icon_hide_password
                    }
                    alt="cart"
                  />
                  {isShowPlaceHolderConfirm && (
                    <img
                      className={" absolute top-0 bottom-0 mt-4 ml-2"}
                      src={icon_placeholder_password}
                      alt="cart"
                    />
                  )}
                </div>
              </div>
              {isShowErrorConfirmPassword && (
                <div className={"text-error-phone"}>
                  {t("errorPasswordConfirm")}
                </div>
              )}
            </div>

            <div className={" w-full flex mr-3"}>
              <div className={"flex mt-3 ml-3 mr-3"}>
                <div onClick={onCheck}>
                  <img
                    className={"flex w-10 h-10"}
                    src={
                      isChecked ? icon_checked_password : ic_uncheck_create_user
                    }
                    alt="cart"
                  />
                </div>
                <div className={"flex ml-2"}>
                  {isLanguageEnglish ? (
                    <div className={"contentPassword"}>
                      {getHighlightedText(
                        t("noteForPassword"),
                        `Terms of Use, Privacy Policy and Membership Policy.`,
                      )}
                    </div>
                  ) : (
                    <div
                      onClick={onShowModalTermAndCondition}
                      className={"contentPassword"}
                    >
                      {getHighlightedText(
                        t("noteForPassword"),
                        `Điều khoản sử dụng, Chính sách bảo mật và Chính sách thành viên.`,
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={"fixed bottom-0 w-full mb-3"}>
            <div>
              <div
                onClick={onConfirmPassword}
                className={
                  createPassword !== "" && passwordConfirm !== "" && isChecked
                    ? "btn-otp-enable relative mt-3.5 ml-5 mr-5 text-center justify-center items-center flex"
                    : "btn-otp-disable relative mt-3.5 ml-5 mr-5 text-center justify-center items-center flex"
                }
              >
                {t("textContinue")}
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className={className}>
        {loading && <ModalLoading />}

        <Modal
          className={"custom-modal-product modal-product-combo"}
          destroyOnClose
          maskStyle={{ borderRadius: 0 }}
          open={isShowModalTermAndCondition}
          footer={null}
          centered
          closable={false}
          zIndex={1200}
        >
          <ModalTermAndCondition
            onCancel={onCancelShowModalTermOf}
            isOpen={isShowModalTermAndCondition}
          />
        </Modal>

        <ModalContent
          icon={icon_info_dialog}
          modalIsOpen={isShowModalConfirmClose}
          title={t("textConfirmCloseModalSignin")}
          titleConfirm={t("ok")}
          titleCancel={t("cancel")}
          isShowBtnCancel={true}
          onCancel={() => setShowModalConfirmClose(false)}
          onConfirm={onConfirmModalConfirmClose}
          content={""}
        />

        <Modal
          className={"custom-modal-product"}
          destroyOnClose
          maskStyle={{ borderRadius: 0 }}
          open={isModalNotifyWrongOtp?.[0]}
          footer={null}
          centered
          closable={false}
        >
          <ModalNotifyWrongOtp
            onCancel={onCancelModalNotifyWrongOtp}
            isOpen={isModalNotifyWrongOtp?.[0]}
            isPassword={isModalNotifyWrongOtp?.[1]}
          />
        </Modal>

        <Modal
          className={"custom-modal-product"}
          destroyOnClose
          maskStyle={{ borderRadius: 0 }}
          open={isShowModalWarning?.[0]}
          footer={null}
          centered
          closable={false}
        >
          <ModalWarning
            onCancel={onCancelModalWarning}
            isOpen={isShowModalWarning?.[0]}
            isContent={isShowModalWarning?.[1]}
          />
        </Modal>

        <Modal
          className={"custom-modal-login"}
          destroyOnClose
          maskStyle={{ borderRadius: 0 }}
          open={isShowModalForgotPassword}
          footer={null}
          centered
          closable={false}
          zIndex={1200}
        >
          <ModalForgotPassword
            onCancel={onCancelModalForgotPassword}
            isOpen={isShowModalForgotPassword}
          />
        </Modal>
        {/* <div className="payment-progress">
          <div className="payment-progress-line" />
          <div className="payment-progress-step is-completed">
            <div className="payment-progress-dot">✓</div>
            <div className="payment-progress-label">
              {t("waitingStaffConfirm")}
            </div>
          </div>
          <div className="payment-progress-step is-current">
            <div className="payment-progress-dot"></div>
            <div className="payment-progress-label">{t("pointAccrual")}</div>
          </div>
          <div className="payment-progress-step">
            <div className="payment-progress-dot" />
            <div className="payment-progress-label">{t("payment")}</div>
          </div>
        </div> */}
        {!isShowOTP && !isShowPasswordView && (
          <div>
            {!isFromCart &&
              (dataUserInfo === "" ? (
                <div onClick={onCancelModal} className="icon_cancel mt-6 ml-4">
                  <img src={icon_cancel_dialog} alt="cart" />
                </div>
              ) : (
                <div
                  onClick={onClearDataInfo}
                  className="icon_cancel mt-6 ml-4"
                >
                  <img src={icon_arrow_back} alt="cart" />
                </div>
              ))}

            <div className="login-intro">
              <div className="login-intro-icon-wrap">
                <img
                  src={icon_app_tgs}
                  className="login-intro-icon"
                  alt="Golden SpoonS"
                />
              </div>

              {dataUserInfo === "" ? (
                <div className="login-intro-copy">
                  <div
                    className={
                      "flex justify-center items-center w-full goldenSpoons"
                    }
                  >
                    {t("goldenSpoonsTitle")}
                  </div>
                  <div
                    className={
                      "flex justify-center items-center w-full mt-1 loginTitleNow"
                    }
                  >
                    {t("loginTitleNow")}
                  </div>
                </div>
              ) : (
                <div className="login-intro-copy">
                  <div
                    className={
                      "flex justify-center items-center w-full goldenSpoons"
                    }
                  >
                    {t("hello")}{" "}
                    {dataUserInfo?.["full-name"] &&
                    dataUserInfo?.["full-name"] !== ""
                      ? dataUserInfo?.["full-name"]
                      : phoneNumber}{" "}
                    !
                  </div>
                  <div
                    className={
                      "flex justify-center items-center w-full mt-1 goldenSpoons"
                    }
                  >
                    <div
                      className={
                        "flex justify-center items-center mt-1 mr-1 contentPhone"
                      }
                    >
                      {t("loginContentWithPhone")}
                    </div>
                    <div
                      className={"flex justify-center items-center mt-1 phone"}
                    >
                      {phoneNumber}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {!isPhoneNumberSuccess && (
              <div>
                <div className={"input-phone relative mt-3.5 ml-5 mr-5"}>
                  <div className={"w-full h-11"}>
                    <input
                      type="number"
                      value={phoneNumber}
                      maxLength={15}
                      placeholder={t("placeholderPhone")}
                      onChange={(e) => setValuePhoneNumber(e.target.value)}
                    />
                  </div>
                  {phoneNumber !== "" && (
                    <div
                      onClick={clearPhone}
                      className={
                        "btn-check flex text-center justify-center items-center absolute top-0 right-0 bottom-0 mr-3"
                      }
                    >
                      <img
                        src={icon_cancel_input_phone}
                        className={"icon-sign-in-tgs"}
                        alt="cart"
                      />
                    </div>
                  )}
                </div>
                {isErrorPhoneNumber && (
                  <div className={"flex mt-1 ml-5 mr-5 text-error-phone"}>
                    {t("textErrorPhone")}
                  </div>
                )}
              </div>
            )}

            {!isPhoneNumberSuccess && (
              <div>
                <div
                  onClick={onInputPass}
                  className={
                    isEnableButton
                      ? "btn-login-enable relative mt-3.5 ml-5 mr-5 text-center justify-center items-center flex"
                      : "btn-login-disable relative mt-3.5 ml-5 mr-5 text-center justify-center items-center flex"
                  }
                >
                  {t("textButtonLogin")}
                </div>

                <div className={" w-full flex mr-3"}>
                  <div className={"flex mt-3 ml-3 mr-3"}>
                    <div onClick={onCheck}>
                      <img
                        className={"flex w-10 h-10"}
                        src={
                          isChecked
                            ? icon_checked_password
                            : ic_uncheck_create_user
                        }
                        alt="cart"
                      />
                    </div>
                    <div className={"flex ml-2"}>
                      {isLanguageEnglish ? (
                        <div className={"contentPassword"}>
                          {getHighlightedText(
                            t("noteForPassword"),
                            `Terms of Use, Privacy Policy and Membership Policy.`,
                          )}
                        </div>
                      ) : (
                        <div
                          onClick={onShowModalTermAndCondition}
                          className={"contentPassword"}
                        >
                          {getHighlightedText(
                            t("noteForPassword"),
                            `Điều khoản sử dụng, Chính sách bảo mật và Chính sách thành viên.`,
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isPhoneNumberSuccess && (
              <div>
                <div className={"input-phone relative mt-3.5 ml-5 mr-5"}>
                  <div className={"w-full h-11"}>
                    <input
                      type={isShowPasswordLogin ? "password" : "text"}
                      maxLength={15}
                      placeholder={t("placeHolderPass")}
                      onChange={(e) => setValuePass(e.target.value)}
                    />
                    <img
                      onClick={setValueShowPasswordLogin}
                      className={" absolute top-0 bottom-0  right-0 mt-2 mr-3"}
                      src={
                        isShowPasswordLogin
                          ? icon_show_password
                          : icon_hide_password
                      }
                      alt="cart"
                    />
                  </div>
                </div>

                {errorPassword !== "" && (
                  <div className={" flex errorOtp mt-1 ml-5"}>
                    {t("errorCorrectPassword")} {errorPassword}{" "}
                    {t("errorCorrectPassword1")}
                  </div>
                )}

                <div
                  onClick={onLoginV3}
                  className={
                    isEnableButtonPassword
                      ? "btn-login-enable relative mt-3.5 ml-5 mr-5 text-center justify-center items-center flex"
                      : "btn-login-disable relative mt-3.5 ml-5 mr-5 text-center justify-center items-center flex"
                  }
                >
                  {t("textContinue")}
                </div>

                <div
                  onClick={() => setModalForgotPassword(true)}
                  className={
                    "text-forgot-pass flex text-center justify-center items-center forgot-password mt-3"
                  }
                >
                  {t("forgotPass")}
                </div>
                {isErrorPhoneNumber && (
                  <div className={"flex mt-1 ml-5 mr-5 text-error-phone"}>
                    {t("textErrorPhone")}
                  </div>
                )}
              </div>
            )}

            {
              isFromCart ? (
                <div>
                  <div
                    className={"flex w-full mt-3.5 justify-center items-center"}
                  >
                    <div className={"line1 flex justify-center items-center"} />
                    <div
                      className={
                        "text-or flex text-center justify-center items-center"
                      }
                    >
                      {t("or")}
                    </div>
                    <div className={"line2 flex justify-center items-center"} />
                  </div>

                  <button
                    type="button"
                    onClick={onLoginWithGoldenGateApp}
                    className="btn-login-golden-gate relative mt-3.5 ml-5 mr-5 text-center justify-center items-center flex"
                  >
                    {t("loginWithGoldenGateApp")}
                  </button>

                  <div
                    onClick={onContinuePayment}
                    className={
                      "btn-continue-payment relative mt-3.5 ml-5 mr-5 text-center justify-center items-center flex"
                    }
                  >
                    {t("textContinuePayment")}
                  </div>
                </div>
              ) : 
              (
                <div>
                  <div
                    className={"flex w-full mt-3.5 justify-center items-center"}
                  >
                    <div className={"line1 flex justify-center items-center"} />
                    <div
                      className={
                        "text-or flex text-center justify-center items-center"
                      }
                    >
                      {t("or")}
                    </div>
                    <div className={"line2 flex justify-center items-center"} />
                  </div>

                  <button
                    type="button"
                    onClick={onLoginWithGoldenGateApp}
                    className="btn-login-golden-gate relative mt-3.5 ml-5 mr-5 text-center justify-center items-center flex"
                  >
                    {t("loginWithGoldenGateApp")}
                  </button>
                </div>
              )
            }
          </div>
        )}

        {isShowOTP && !isShowPasswordView && (
          <div>
            {!isFromCart && (
              <div onClick={onClearShowOtp} className="icon_cancel mt-6 ml-4">
                <img src={icon_arrow_back} alt="cart" />
              </div>
            )}

            <div>
              <div className={"flex justify-center items-center goldenSpoons"}>
                {t("verifyOTPTitle")}
              </div>
              <div className={"flex w-full justify-center items-center"}>
                <div
                  className={
                    "flex justify-center items-center mt-1 loginTitleNow"
                  }
                >
                  {t("inputOTPTitle")}
                </div>
                <div
                  className={
                    "flex justify-center items-center mt-1 ml-1 phoneNumberOTP"
                  }
                >
                  {phoneNumber}
                </div>
              </div>

              <div>
                <div className={"flex justify-center items-center w-full mt-3"}>
                  <InputOTP
                    inputStyle={{
                      border: "1px solid #D9D9D9",
                      borderRadius: "8px",
                      width: "54px",
                      height: "54px",
                      fontSize: "24px",
                      color: "#1A1A1A",
                      fontWeight: "700",
                    }}
                    onChange={setValueOtp}
                    value={otp}
                    length={4}
                    inputType={"numeric"}
                    autoFocus={true}
                  />
                </div>

                {errorOtp !== "" && (
                  <div
                    className={
                      " flex items-center justify-center text-center errorOtp mt-1"
                    }
                  >
                    {t("errorOtp")} {errorOtp} {t("errorOtp1")}
                  </div>
                )}
              </div>
            </div>

            <div className={"fixed bottom-0 w-full mb-3"}>
              <div>
                {seconds > 0 ? (
                  <div className={" flex w-full justify-center items-center"}>
                    <div
                      className={
                        " flex items-center justify-center text-center loginTitleNow"
                      }
                    >
                      {t("titleResendOTP")} 00 : {("0" + seconds).slice(-2)}
                    </div>
                  </div>
                ) : (
                  <div
                    onClick={resendOTP}
                    className={" flex w-full justify-center items-center"}
                  >
                    <div
                      className={
                        " flex items-center justify-center text-center resendOtp"
                      }
                    >
                      {t("titleResendOTP1")}
                    </div>
                  </div>
                )}

                <div
                  onClick={onSendOtp}
                  className={
                    isEnableButtonVerifyOTP
                      ? "btn-otp-enable relative mt-3.5 ml-5 mr-5 text-center justify-center items-center flex"
                      : "btn-otp-disable relative mt-3.5 ml-5 mr-5 text-center justify-center items-center flex"
                  }
                >
                  {t("textContinue")}
                </div>
              </div>
            </div>
          </div>
        )}

        {isShowPasswordView && renderPasswordView()}

        <ModalContent
          icon={icon_info_dialog}
          modalIsOpen={isShowModalError?.[0]}
          title={t("errorTitle")}
          titleConfirm={t("close")}
          titleCancel={t("callStaffTitle")}
          isShowBtnCancel={false}
          onConfirm={() => setShowModalError([false, ""])}
          content={t("contentErrorTimeOut")}
          error={isShowModalError?.[1]}
        />

        <ModalContentV2
          icon={<IconInfoWarningDialog />}
          modalIsOpen={isShowAppLoginWarning}
          title={
            appLoginWarningMessageParts.title || t("cannotOpenGoldenGateApp")
          }
          titleByCash=""
          titleConfirm={t("close")}
          isShowBtnCancel={false}
          zIndex={200001}
          maskClosable={false}
          onConfirm={() => {
            setShowAppLoginWarning(false);
            setAppLoginWarningMessage("");
          }}
          content={appLoginWarningMessageParts.content}
          error=""
        />

        <ModalContentV2
          icon={<IconInfoWarningDialog />}
          modalIsOpen={Boolean(appLoginCallbackWarning)}
          title={
            appLoginCallbackWarning ===
            APP_LOGIN_CALLBACK_WARNING.NO_INTERNET
              ? t("appLoginNoInternetTitle")
              : appLoginCallbackWarning ===
                  APP_LOGIN_CALLBACK_WARNING.SESSION_EXPIRED
                ? t("appLoginSessionExpiredTitle")
                : appLoginCallbackMessageParts.title || t("appLoginSyncError")
          }
          titleByCash=""
          titleConfirm={t("close")}
          isShowBtnCancel={false}
          zIndex={200001}
          maskClosable={false}
          onConfirm={closeAppLoginCallbackWarning}
          content={
            appLoginCallbackWarning ===
            APP_LOGIN_CALLBACK_WARNING.NO_INTERNET
              ? t("appLoginNoInternetContent")
              : appLoginCallbackWarning ===
                  APP_LOGIN_CALLBACK_WARNING.SESSION_EXPIRED
                ? t("appLoginSessionExpiredContent")
                : appLoginCallbackMessageParts.content
          }
          error=""
        />
      </div>
    );
  },
);

const ModalLogin = memo((props) => {
  const { isFromCart, setModalLogin, setShowQrCodeConfirmPayment } = props;
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      {!!isFromCart && (
        <StepPointAccrual
          setModalLogin={setModalLogin}
          setShowQrCodeConfirmPayment={setShowQrCodeConfirmPayment}
        />
      )}
      <ModalLoginInner {...props} />
    </GoogleReCaptchaProvider>
  );
});

export default styled(ModalLogin)`
  position: relative;
  height: 100%;
  width: 100%;
  .errorOtp {
    color: #e32e2e;
    line-height: 18px;
    font-size: 12px;
    font-weight: 400;
    font-family: "Manrope-Medium", sans-serif;
  }
  .payment-progress {
    position: relative;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    align-items: start;
    padding: 12px 12px 4px;
    background: #ffffff;
  }
  .payment-progress-line {
    position: absolute;
    top: 24px;
    left: calc(16.666% + 18px);
    right: calc(16.666% + 18px);
    height: 1px;
    background: #d9d9d9;
  }
  .payment-progress-step {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    text-align: center;
  }
  .payment-progress-dot {
    width: 24px;
    height: 24px;
    border-radius: 999px;
    border: 1.5px solid #d9d9d9;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 12px;
    line-height: 12px;
    font-family: "Manrope-Bold", sans-serif;
  }
  .payment-progress-label {
    color: #999999;
    font-size: 13px;
    line-height: 20px;
    font-family: "Manrope-Medium", sans-serif;
  }
  .payment-progress-step.is-completed .payment-progress-dot {
    border-color: #45c149;
    background: #45c149;
  }
  .payment-progress-step.is-completed .payment-progress-label {
    color: #4d4d4d;
  }
  .payment-progress-step.is-current .payment-progress-dot {
    border-color: #1a1a1a;
    background: radial-gradient(circle, #1a1a1a 0 3px, #ffffff 4px);
  }
  .payment-progress-step.is-current .payment-progress-label {
    color: #1a1a1a;
    font-family: "Manrope-Bold", sans-serif;
  }

  .resendOtp {
    color: #2083da;
    line-height: 20px;
    font-size: 15px;
    font-weight: 600;
    font-family: "Manrope-Medium", sans-serif;
  }
  .phoneNumberOTP {
    color: #1a1a1a;
    line-height: 18px;
    font-size: 12px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .text-error-phone {
    color: #e32e2e;
    line-height: 18px;
    font-size: 12px;
    font-weight: 400;
    font-family: "Manrope-Medium", sans-serif;
  }
  .forgot-password {
    color: #2083da;
    line-height: 20px;
    font-size: 15px;
    font-weight: 600;
    font-family: "Manrope-Medium", sans-serif;
  }
  .contentPhone {
    color: #4d4d4d;
    line-height: 18px;
    font-size: 12px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .phone {
    color: #1a1a1a;
    line-height: 18px;
    font-size: 12px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .text-or {
    color: #4d4d4d;
    line-height: 22px;
    font-size: 15px;
    font-weight: 400;
    font-family: "Manrope-Medium", sans-serif;
    width: 20%;
  }
  .line1 {
    margin-left: 20px;
    width: 40%;
    height: 1px;
    background: #e6e6e6;
  }
  .line2 {
    margin-right: 20px;
    width: 40%;
    height: 1px;
    background: #e6e6e6;
  }
  input {
    margin-top: 10px;
    margin-left: 10px;
    height: 22px;
    width: 70%;
  }
  input:focus {
    outline: none;
    border: none;
    border: 0px solid white;
  }
  textarea {
    margin-top: 10px;
    margin-left: 10px;
    height: 22px;
    width: 70%;
  }
  textarea:focus {
    outline: none;
    border: none;
    border: 0px solid white;
  }
  .btn-login-disable {
    background: #cccccc;
    border-radius: 6px;
    height: 44px;
    color: #ffffff;
    line-height: 20px;
    font-size: 14px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .btn-continue-payment {
    background: #ffffff;
    border: 1px solid #808080;
    border-radius: 6px;
    height: 44px;
    color: #1a1a1a;
    line-height: 20px;
    font-size: 14px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .btn-login-golden-gate {
    width: calc(100% - 40px);
    border: 0;
    background: #e4b652;
    border-radius: 6px;
    height: 44px;
    color: #1a1a1a;
    line-height: 20px;
    font-size: 14px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .btn-login-enable {
    background: #1a1a1a;
    border-radius: 6px;
    height: 44px;
    color: #ffffff;
    line-height: 20px;
    font-size: 14px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .btn-otp-disable {
    background: #cccccc;
    border-radius: 6px;
    height: 44px;
    color: #ffffff;
    line-height: 20px;
    font-size: 14px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .btn-otp-enable {
    background: #1a1a1a;
    border-radius: 6px;
    height: 44px;
    color: #ffffff;
    line-height: 20px;
    font-size: 14px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .checkout-login-header {
    position: sticky;
    top: 0;
    z-index: 3;
    background: #ffffff;
    padding: 12px 0 6px;
  }
  .checkout-login-progress {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0 12px;
    padding-top: 0;
  }
  .checkout-login-progress-line {
    position: absolute;
    top: 14px;
    left: 42px;
    right: 42px;
    height: 1px;
    background: #d9d9d9;
  }
  .checkout-login-progress-step {
    position: relative;
    z-index: 1;
    width: 33.3333%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .checkout-login-progress-dot {
    width: 32px;
    height: 32px;
    border-radius: 999px;
    border: 2px solid #d9d9d9;
    background: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    line-height: 1;
    font-family: "Manrope-Bold", sans-serif;
  }
  .checkout-login-progress-dot-inner {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: #1a1a1a;
    display: block;
  }
  .checkout-login-progress-step.is-completed .checkout-login-progress-dot {
    border-color: #45c149;
    background: #45c149;
    color: #ffffff;
  }
  .checkout-login-progress-step.is-current .checkout-login-progress-dot {
    border-color: #1a1a1a;
    background: #ffffff;
    color: #1a1a1a;
  }
  .checkout-login-progress-label {
    margin-top: 12px;
    color: #808080;
    font-size: 16px;
    line-height: 24px;
    font-family: "Manrope-Medium", sans-serif;
  }
  .checkout-login-progress-step.is-current .checkout-login-progress-label {
    color: #1a1a1a;
    font-family: "Manrope-Bold", sans-serif;
  }
  .input-phone {
    border-radius: 6px;
    border: 1px solid #d9d9d9;
  }
  .login-intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 12px 20px 0;
    text-align: center;
  }
  .login-intro-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 88px;
    height: 88px;
    margin: 0 auto;
  }
  .login-intro-icon {
    width: 72px;
    height: 72px;
    display: block;
    object-fit: contain;
  }
  .login-intro-copy {
    width: 100%;
    margin-top: 8px;
  }
  .goldenSpoons {
    line-height: 26px;
    color: #1a1a1a;
    font-size: 18px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .loginTitleNow {
    line-height: 18px;
    color: #4d4d4d;
    font-size: 13px;
    font-weight: 400;
    font-family: "Manrope-Medium", sans-serif;
  }
  .contentPassword {
    line-height: 22px;
    color: #4d4d4d;
    font-size: 15px;
    font-weight: 400;
    font-family: "Manrope-Medium", sans-serif;
  }
`;
